import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "antd";
import { countryListHttp } from "@/api";

const CountryLanguage = ({ visible, onClick, handleCounty }) => {
  const { t, i18n } = useTranslation();
  const [languageList, setLanguageList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [countryIdCache, setCountryCache] = useState("");
  const [languageCache, setLanguageCache] = useState("jp");
  const handleChange = (type, id) => {
    if (type) {
      setCountryCache(id);
      handleCounty(id);
      sessionStorage.setItem("websiteCountryId", id);
    } else {
      setLanguageCache(id);
      if (localStorage.getItem("websiteLanguage")) {
        i18n.changeLanguage(localStorage.getItem("websiteLanguage"));
        setLanguageCache(localStorage.getItem("websiteLanguage"));
      } else {
        setLanguageCache(languageCache);
      }
      localStorage.setItem("websiteLanguage", id);
    }
  };
  const handleCacheChange = (type, id) => {
    if (type) {
      setCountryCache(id);
      // setCountry(id);
      // handleCounty(id);
    } else {
      setLanguageCache(id);
    }
  };
  const getData = () => {
    countryListHttp().then((res) => {
      if (res.data.code === 100) {
        setCountryList(res.data.data);
      }
    });
    setLanguageList([
      { id: "jt", name: "简体中文" },
      { id: "ft", name: "繁体中文" },
      { id: "en", name: "英语" },
      { id: "jp", name: "日本语" },
    ]);
    getLanguage();
  };
  const getLanguage = () => {
    const query = window.location.search.split("=")[1] || "";
    switch (query) {
      case "cn":
        handleChange(0, "jt");
        handleChange(1, 208);
        break;
      case "hk":
        handleChange(0, "ft");
        handleChange(1, 19464);
        break;
      case "en":
        handleChange(0, "en");
        handleChange(1, 617);
        break;
      default:
        handleChange(0, "jp");
        handleChange(1, 17829);
        break;
    }
  };
  const handleOk = () => {
    sessionStorage.setItem("websiteCountryId", countryIdCache);
    localStorage.setItem("websiteLanguage", languageCache);
    handleCounty(countryIdCache);
    i18n.changeLanguage(languageCache);
    onClick(false);
  };
  const handleCancel = () => {
    setCountryCache(Number(sessionStorage.getItem("websiteCountryId")));
    setLanguageCache(localStorage.getItem("websiteLanguage"));
    onClick(false);
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal
      title={t(99)}
      visible={visible}
      className="countryLanguageModal"
      width="60%"
      footer={null}
      onCancel={() => handleCancel()}
    >
      <div>
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>{t(31)}</div>
        <div className="countryLanguageBox">
          {countryList.length
            ? countryList.map((i) => {
              return (
                <div
                  className={`${i.countryId === countryIdCache ? "currentSelect" : ""
                    } countryLanguage`}
                  title={i.countryName}
                  key={i.countryId}
                  onClick={() => handleCacheChange(1, i.countryId)}
                >
                  <div className="countryIcon">
                    <img
                      src={i.countryIcon}
                      className="countryIconImg"
                      alt=""
                    />
                  </div>
                  <div>{i.countryName}</div>
                </div>
              );
            })
            : null}
        </div>
      </div>
      <hr />
      <div>
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>{t(32)}</div>
        <div className="countryLanguageBox">
          {languageList.length
            ? languageList.map((i) => {
              return (
                <div
                  className={`${i.id === languageCache ? "currentSelect" : 'defaultLang'}`}
                  title={i.name}
                  key={i.id}
                  onClick={() => handleCacheChange(0, i.id)}
                >
                  {i.name}
                </div>
              );
            })
            : null}
        </div>
      </div>
      <div className="countryLanguageSelect">
        <Button type="primary" onClick={() => handleOk()}>
          {t(19)}
        </Button>
        <Button onClick={() => handleCancel()}>{t(127)}</Button>
      </div>
    </Modal>
  );
};
export default CountryLanguage;
